// extracted by mini-css-extract-plugin
export default {"table":"MetaInfo_table__7s2dY","relativeDate":"MetaInfo_relativeDate__83szM","date":"MetaInfo_date__J1IoD"};